// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/value-proposition-item/value-proposition-item.component.scss
// module id = 71
// module chunks = 0